import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_48.png'


const _withScopeId = n => (_pushScopeId("data-v-235f5413"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-100 flex-column" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex-row-center-sb" }
const _hoisted_4 = { class: "fz-14 co-1F2533" }
const _hoisted_5 = { class: "flex-row-center-start" }
const _hoisted_6 = {
  key: 0,
  class: "point mr-4"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fz-12 co-949CA9" }, "立即处理", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-10 ml-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "fz-12 co-949CA9 mt-6" }

import { ref } from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderPop',
  setup(__props, { expose: __expose }) {

	const pop = ref(false);
	const ToDoList = ref([{
		title: "您有待入库订单待审核",
		time: "2023-11-29 15:10:12",
		is_read: 0,
	}, {
		title: "您有待入库订单待审核",
		time: "2023-11-29 15:10:12",
		is_read: 0,
	}, {
		title: "您有待入库订单待审核",
		time: "2023-11-29 15:10:12",
		is_read: 0,
	}, {
		title: "您有待入库订单待审核",
		time: "2023-11-29 15:10:12",
		is_read: 0,
	}, {
		title: "您有待入库订单待审核",
		time: "2023-11-29 15:10:12",
		is_read: 0,
	}]);
	
	const open = () => {
		pop.value = true;
	};
	const close = () => {
		pop.value = false;
	};

	__expose({
		open,
		close,
	})

return (_ctx: any,_cache: any) => {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: pop.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pop).value = $event)),
    title: "",
    "modal-class": "mode-class",
    "with-header": false,
    direction: "rtl",
    size: "25%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_PageTitle, { name: "待办事项" }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_scrollbar, { height: "100%" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ToDoList.value, (v, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ptb-12 boderb1-EBEBED pointer",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(v.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      (v.is_read == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true),
                      _hoisted_7,
                      _hoisted_8
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(v.time), 1)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})